import { useLocation } from 'react-router-dom';

/**
 * Custom hook for generating canonical URLs
 * @param customPath Optional custom path to use instead of current location
 * @returns The canonical URL string
 */
const useCanonicalUrl = (customPath?: string): string => {
  const location = useLocation();

  // Determine the base URL based on environment
  const getBaseUrl = (): string => {
    // In development or non-production environments, don't add canonical URLs
    // or use localhost for testing
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:3001'; // React dev server default port
    }
    
    // For staging/preview deployments, might want to skip canonical
    // or use the staging URL - but for now, always use production
    return 'https://www.wavescoop.com';
  };

  // Get the path to use (custom or current)
  const path = customPath || location.pathname;
  
  // Clean the path - remove query parameters and trailing slashes
  const cleanPath = path.split('?')[0].replace(/\/+$/, '') || '/';
  
  // Combine base URL and clean path
  const canonicalUrl = `${getBaseUrl()}${cleanPath === '/' ? '' : cleanPath}`;
  
  return canonicalUrl;
};

export default useCanonicalUrl; 